import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue'
  import KetchUpButton from '@/components/common/KetchUpButton.vue'

  import useI18n from '@/composables/useI18n'
  import useCourse from '@/composables/useCourse'

  import eventBus from '@/main'

  
export default /*#__PURE__*/_defineComponent({
  __name: 'CourseDetailsAction',
  props: {
    nextActionDisabled: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['show-details', 'next-action'],
  setup(__props) {

  const { course } = useCourse()
  const { translateString } = useI18n()

  

  

  const nextActionText = computed(() => {
    if (course.value?.purchased) {
      return translateString('courses.continue')
    }

    return translateString('courses.keepTesting')
  })

  const showCourseDetails = () => {
    eventBus.$emit('show-modal', {
      modalContentComponent: 'CourseDetailsModal',
      cssClass: 'course-details-modal',
      modalCloseCallback: (callback: () => void) => {
        if (typeof callback === 'function') callback()
      },
    })
  }

return { __sfc: true,course, translateString, nextActionText, showCourseDetails, computed, KetchUpButton, useI18n, useCourse, eventBus }
}

})